import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCategorySubcategories,
  getCategorySubcategoryErrorMessage,
} from "../../services/categorySubcategoryService";

const initialState = {
  categories: [],
  subCategoriesByCategoryId: {},
  status: "idle",
  error: "",
};

/**
 * Loads the combined category/subcategory data from the API once and saves it in Redux state.
 */
export const fetchCategorySubcategories = createAsyncThunk(
  "categorySubcategory/fetchCategorySubcategories",
  async (_, { rejectWithValue }) => {
    try {
      return await getCategorySubcategories();
    } catch (error) {
      return rejectWithValue(getCategorySubcategoryErrorMessage(error));
    }
  },
  {
    // Skips duplicate calls (e.g. React StrictMode's double effect invocation in dev).
    condition: (_, { getState }) => {
      const { status } = getState().categorySubcategory;
      return status !== "loading" && status !== "succeeded";
    },
  }
);

const categorySubcategorySlice = createSlice({
  name: "categorySubcategory",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategorySubcategories.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchCategorySubcategories.fulfilled, (state, action) => {
        state.categories = action.payload.categories;
        state.subCategoriesByCategoryId = action.payload.subCategoriesByCategoryId;
        state.status = "succeeded";
      })
      .addCase(fetchCategorySubcategories.rejected, (state, action) => {
        state.categories = [];
        state.subCategoriesByCategoryId = {};
        state.status = "failed";
        state.error = action.payload || "Grievance categories could not be loaded. Please try again.";
      });
  },
});

export default categorySubcategorySlice.reducer;
